import { Button, Modal } from "@/components";
import styles from "./DeleteAssetModal.module.scss";

type DeleteAssetModalProps = {
  isOpen: boolean;
  fileName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export const DeleteAssetModal = ({
  isOpen,
  fileName,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteAssetModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={isDeleting ? () => {} : onClose}>
      <div className={styles["comp"]}>
        <div>
          <div className={styles["comp__heading"]}>Usunąć plik?</div>
          <p className={styles["comp__description"]}>Czy na pewno chcesz usunąć ten plik?</p>
          <div className={styles["comp__fileName"]} title={fileName}>
            „{fileName}”
          </div>
        </div>

        <div className={styles["comp__actions"]}>
          <Button type="button" variant="secondary" onClick={onClose} disabled={isDeleting}>
            Anuluj
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Usuwanie…" : "Usuń"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
